import * as React from 'react';

import ChatWindowHeader from './ChatWindowHeader';
import FatalError from './FatalError';
import ToggleButton from './ToggleButton';

export const AppErrorFallback: React.FC = () => {
	return (
		<React.Fragment>
			<div
				data-testid="app-error-fallback"
				className="c-app-error-fallback md:rounded-md fixed flex flex-col items-center justify-between overflow-hidden bg-white"
			>
				<div className="relative flex flex-col flex-grow w-full">
					<ChatWindowHeader
						clickCloseCallback={() => window.AOChatbot.reload()}
						showDivider
					></ChatWindowHeader>
					<FatalError reloadCallback={() => window.AOChatbot.reload()} />
				</div>
			</div>
			<ToggleButton isOpen onClick={() => window.AOChatbot.reload()} />
		</React.Fragment>
	);
};

export default AppErrorFallback;
